import { getLocale } from "../runtime";

const sv_yousave = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Du sparar`
};

const yousave = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_yousave(inputs)
	return "youSave";
};

export { yousave as "youSave" };